const defaultState = {
  category: '',
  categories: {},
  isLoading: false,
  isCollapsed: false,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'menu/SET_CATEGORIES':
      return {
        ...state,
        categories: action.categories,
      };
    case 'menu/TOGGLE_MENU_COLLAPSED':
      return {
        ...state,
        isCollapsed: !state.isCollapsed,
      };
    default:
      return state;
  }
};
